// src/pages/CheckoutResultPage.jsx
// Landing pages for the Stripe-hosted Checkout return (success_url / cancel_url
// set by createStripeCheckoutSession). Charcoal theme (extends checkout design).
//
// Entitlements are granted asynchronously by onStripeWebhook, so success shows a
// "unlocking shortly" message; the dashboard's entitlement listener reflects
// access as soon as the webhook commits.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconCheck } from '../components/icons.jsx';

export default function CheckoutResultPage({ outcome }) {
    const navigate = useNavigate();
    const success = outcome === 'success';
    return (
        <div className="page-fade-in min-h-[calc(100vh-4rem)] bg-charcoal-bg flex items-center justify-center px-4 py-12">
            <div className="max-w-lg w-full text-center border border-charcoal-accent/30 bg-charcoal-page/60 p-12 decorative-corner text-charcoal-accent">
                <div className="w-16 h-16 rounded-full border-2 border-charcoal-accent flex items-center justify-center mx-auto mb-6">
                    <IconCheck className="w-8 h-8 text-charcoal-accent" />
                </div>
                {success ? (
                    <>
                        <h2 className="font-display text-3xl text-charcoal-text mb-4">Check your library</h2>
                        <p className="font-serif text-charcoal-muted mb-8 leading-relaxed">
                            After a successful payment, your packs appear in your library once confirmation
                            is received. This can take a few moments. Each purchase includes 12 months of
                            access, with no automatic renewal. If you were charged but access is missing,
                            contact learn@daniellenglish.com before paying again.
                        </p>
                    </>
                ) : (
                    <>
                        <h2 className="font-display text-3xl text-charcoal-text mb-4">Checkout cancelled</h2>
                        <p className="font-serif text-charcoal-muted mb-8 leading-relaxed">
                            You have returned without completing this checkout. Your cart is still saved.
                            If you see a charge, check your library or contact learn@daniellenglish.com before trying again.
                        </p>
                    </>
                )}
                <button onClick={() => navigate(success ? '/dashboard' : '/cart')}
                    className="px-5 py-3 bg-charcoal-accent text-charcoal-pageDark font-display text-sm hover:bg-charcoal-accentLight transition-colors btn-sweep font-semibold">
                    {success ? 'Go to My Library' : 'Back to Cart'}
                </button>
            </div>
        </div>
    );
}
